import type { Selector } from '../state/types';
import type { CreditAccount } from './types';

export const selectCreditAccount: Selector<CreditAccount | null | undefined, string | null | undefined> = (state, organizationId) => (organizationId ? state.creditAccounts[organizationId] : undefined);
export const selectRecipients: Selector<string[], string | null | undefined> = (state, organizationId) => {
  const creditAccount = selectCreditAccount(state, organizationId);
  return creditAccount && creditAccount.alertAddresses.length ? creditAccount.alertAddresses : [''];
};
